import { StateCreator } from 'zustand';
import { ComponentTypes, Dimensions } from '../componentUtils';
import { storeResetFns } from '.';

type State = {
	resizedComponents: Map<keyof typeof ComponentTypes, Dimensions>;
};

type Actions = {
	setResizedComponents: (value: any) => void;
	resetComponentSliceData: () => void;
};

export type ComponentState = State & Actions;

const initialState = {
	resizedComponents: null,
};

export const createComponentSlice: StateCreator<ComponentState> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});
	return {
		...initialState,
		setResizedComponents: value => {
			set({
				resizedComponents: value,
			});
		},
		resetComponentSliceData: () => {
			set(initialState);
		},
	};
};
